import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes, SubmissionError } from 'redux-form';
import { required } from '../../ReduxForm/validation';
import {
  ReduxFormField,
  ReduxFormError,
  ForgotPasswordLink,
  ReduxFormSubmitButton,
} from '../Forms/index';
import { LOGIN_ERROR_EMAIL } from '../../../../ReduxStorage/Auth/Login/constants';
import { noop } from '../../../utilities/functions';

import './styles.scss';

class _LoginForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    onForgotPassword: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
  };

  onSubmit = ({ email, password }) => {
    const { onLogin } = this.props;
    return onLogin(email, password).then(noop, (e) => {
      let errors = { _error: e.message };
      if (e.message === LOGIN_ERROR_EMAIL) {
        errors = { email: e.message };
      }
      throw new SubmissionError(errors);
    });
  };

  render() {
    const { handleSubmit, error, onForgotPassword, submitting } = this.props;

    return (
      <div className="login-form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            name="email"
            type="text"
            label="Email or profile name"
            component={ReduxFormField}
            validate={required}
          />
          <Field
            name="password"
            type="password"
            label="Password"
            component={ReduxFormField}
            validate={required}
          />
          <ForgotPasswordLink onForgotPassword={onForgotPassword} />
          {error && <ReduxFormError error={error} />}
          <ReduxFormSubmitButton label="Log in" {...{ submitting }} />
        </form>
      </div>
    );
  }
}

export const LoginForm = reduxForm({
  form: 'login',
})(_LoginForm);

export const ModalLoginForm = reduxForm({
  form: 'modalLogin',
})(_LoginForm);
